var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-l-r-0 login ",class:_vm.bgClass,attrs:{"id":"app"}},[_c('Header'),_c('notifications',{attrs:{"group":"auth","position":"bottom right"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }